var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFind"},[_c('div',{staticStyle:{"margin-top":"50vh"}},[_vm._v(" "+_vm._s(_vm.fileName)+"文件不存在，请检查地址是否存在此文件： "),_c('a',{attrs:{"target":"_blank","href":_vm.url}},[_vm._v(_vm._s(_vm.url))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }